const pm = {
  // ==================== PLANT MAINTENANCE (Platzhalter / Modul-Kachel) ====================
  'pm.title': 'Plant Maintenance',
  'pm.subtitle': 'Manage maintenance orders, maintenance plans and technical objects',

  // ==================== PLANT-MAINTENANCE-MODUL (portiert aus i18n/*.json, Praefix pm.) ====================
  'pm.common.loading': 'Loading…',
  'pm.common.back': 'Back',
  'pm.common.next': 'Next',
  'pm.common.done': 'Done',
  'pm.common.clear': 'Clear',
  'pm.common.loadError': 'Could not load data.',
  'pm.common.retry': 'Retry',
  'pm.header.reset': 'Reset data',
  'pm.header.resetConfirm': 'Delete all data created during testing and reset to the initial state?',
  'pm.role.mechanic': 'Mechanic',
  'pm.role.supervisor': 'Supervisor',
  'pm.search.placeholder': 'e.g. pump, 10004711…',
  'pm.home.title': 'What are you looking for?',
  'pm.home.subtitle': 'Equipment, order or material — just type.',
  'pm.home.actions': 'Actions',
  'pm.recent.title': 'Last used',
  'pm.home.soon': 'soon',
  'pm.home.notActive': '“{label}” is not active yet in this prototype.',
  'pm.home.resetDone': 'Demo data reset.',
  'pm.action.create-order.label': 'Create order',
  'pm.action.create-order.sub': 'In 3 steps',
  'pm.action.create-notification.label': 'Create notification',
  'pm.action.create-notification.sub': 'Problem + photo',
  'pm.action.my-orders.label': 'My orders',
  'pm.action.my-orders.sub': 'List & confirmation',
  'pm.action.material-search.label': 'Find material',
  'pm.action.material-search.sub': 'Visual search',
  'pm.action.backlog.label': 'Order backlog',
  'pm.action.backlog.sub': 'Open orders',
  'pm.action.approvals.label': 'Approvals',
  'pm.action.approvals.sub': 'Review & approve',
  'pm.order.steps.device': 'Equipment',
  'pm.order.steps.problem': 'Problem',
  'pm.order.steps.confirm': 'Confirm',
  'pm.order.whichDevice': 'Which equipment?',
  'pm.order.problemLabel': 'What\'s the problem?',
  'pm.order.problemPlaceholder': 'Describe briefly…',
  'pm.order.pastNotifications': 'Past notifications on this equipment:',
  'pm.order.priority': 'Priority',
  'pm.order.confirmTitle': 'Confirm order',
  'pm.order.fieldDevice': 'Equipment',
  'pm.order.fieldProblem': 'Problem',
  'pm.order.fieldPriority': 'Priority',
  'pm.order.fieldOrderType': 'Order type',
  'pm.order.fieldPlant': 'Plant',
  'pm.order.fieldWorkCenter': 'Work center',
  'pm.order.longTextLabel': 'Details (optional)',
  'pm.order.longTextPlaceholder': 'Detailed description — dictation goes here, no character limit.',
  'pm.order.fieldLongText': 'Details',
  'pm.order.detailsShow': 'Change details',
  'pm.order.detailsHide': 'Hide details',
  'pm.order.defaultsNote': 'Pre-filled from your profile. (Editing limited in the prototype.)',
  'pm.order.createBtn': 'Create order',
  'pm.order.creating': 'Creating…',
  'pm.order.createHint': 'Created in SAP (via the mock adapter)',
  'pm.order.successTitle': 'Order created',
  'pm.order.orderNumber': 'Order number',
  'pm.order.duplicateNote': '(already existed — no duplicate created)',
  'pm.order.addPartsNow': 'Open order & add parts',
  'pm.order.openCreated': 'Open order',
  'pm.order.errorPrefix': 'Error',
  'pm.priority.low': 'Low',
  'pm.priority.mid': 'Medium',
  'pm.priority.high': 'High',
  // Order-type codes -> intent (demo customizing; per customer from sap-contract-requirements.md §6a).
  'pm.orderType.W001': 'Maintenance',
  'pm.orderType.W002': 'Repair',
  // SAP transparency panel (SapPayloadPanel): fields going to / coming from SAP.
  'pm.sap.show': 'Show SAP fields',
  'pm.sap.hide': 'Hide SAP fields',
  'pm.sap.toSapNote': 'These fields are transferred to SAP.',
  'pm.sap.fromSapNote': 'These fields came from SAP (mock) as shown.',
  'pm.sap.plannedStart': 'Planned start',
  'pm.sap.plannedEnd': 'Planned end',
  'pm.status.CRTD': 'Created',
  'pm.status.REL': 'Released',
  'pm.status.CNF': 'Confirmed',
  'pm.status.TECO': 'Completed',
  'pm.dash.show': 'Show dashboard',
  'pm.dash.hide': 'Hide dashboard',
  'pm.dash.pendingApprovals': 'Pending approvals',
  'pm.dash.openOrders': 'Open orders',
  'pm.dash.overdue': 'Overdue',
  'pm.dash.openNotifications': 'Open notifications',
  'pm.dash.byStatus': 'By status',
  'pm.dash.byType': 'By order type',
  'pm.dash.recentNotifications': 'Latest notifications',
  'pm.dash.empty': 'No data.',
  'pm.dash.mockBadge': 'Mock data',
  'pm.dash.clickHint': 'Click for list',
  'pm.week.next7': 'Next 7 days',
  'pm.week.my': 'My week',
  'pm.week.overdue': 'Overdue',
  'pm.week.today': 'Today',
  'pm.week.unscheduled': 'unscheduled',
  'pm.orders.myTitle': 'My orders',
  'pm.orders.backlogTitle': 'Order backlog',
  'pm.orders.approvalsTitle': 'Approvals',
  'pm.orders.approvalsHint': 'Orders in status “Created” — review and release.',
  'pm.orders.empty': 'No orders found.',
  'pm.orders.countSuffix': 'orders',
  'pm.orders.countOne': 'order',
  'pm.detail.title': 'Order',
  'pm.detail.operations': 'Operations',
  'pm.detail.components': 'Components',
  'pm.detail.confirmedShort': 'confirmed',
  'pm.detail.hours': 'Hours',
  'pm.detail.finalConfirmation': 'Final confirmation (complete the operation)',
  'pm.detail.confirmSubmit': 'Post time',
  'pm.detail.confirming': 'Posting…',
  'pm.detail.confirmPosted': 'Confirmation posted',
  'pm.detail.confirmReplayed': 'already posted — no duplicate',
  'pm.detail.release': 'Release order',
  'pm.detail.releasing': 'Releasing…',
  'pm.detail.releasedNote': 'Order released — work can start.',
  'pm.detail.qty': 'Quantity',
  'pm.detail.notFound': 'Order not found.',
  // Hand over components (SAP creates reservation/purchase requisition itself)
  'pm.comp.add': 'Add component',
  'pm.comp.addBtn': 'Hand over to SAP',
  'pm.comp.adding': 'Handing over…',
  'pm.comp.stockAtPlant': 'Available at plant',
  'pm.comp.shortfallHint': 'On shortfall, SAP automatically creates a purchase requisition.',
  'pm.comp.resShort': 'Res.',
  'pm.comp.prShort': 'PR',
  'pm.materials.title': 'Find material',
  'pm.materials.subtitle': 'Description, number or characteristic — e.g. “bearing” or “45 mm”.',
  'pm.materials.placeholder': 'e.g. bearing, seal, 9000012352…',
  'pm.materials.available': 'available',
  'pm.materials.bin': 'Storage bin',
  'pm.materials.outOfStock': 'Out of stock',
  'pm.materials.noResults': 'No results.',
  'pm.materials.loadingStock': 'Loading stock…',
  // Voice input (tier 1, behind the company-wide pm_features.voice flag)
  'pm.voice.disabledMsg': 'Voice input is disabled company-wide. Browser dictation sends audio to the browser vendor (Google/Microsoft/Apple) — enabling it must be confirmed company-wide, or a local speech model can be set up on company servers instead.',
  'pm.voice.unsupported': 'This browser does not support speech recognition (e.g. Firefox). Please use Chrome, Edge or Safari.',
  'pm.voice.start': 'Start dictation (push-to-talk)',
  'pm.voice.stop': 'Stop dictation',
  'pm.voice.listening': 'Listening',
  'pm.voice.transcribing': 'Transcribing…',
  'pm.voice.serverError': 'Local speech model is not reachable. Please inform an administrator (check the server / re-run the connection test).',
  'pm.voice.micDenied': 'Microphone access was denied — please allow it in the browser settings (or company policy).',
  'pm.voice.noMic': 'No microphone found. Please connect one and check that Windows allows apps to access the microphone (Settings → Privacy → Microphone).',
  'pm.voice.insecure': 'Microphone access only works over localhost or HTTPS — please open the app via a secure address.',
  'pm.voice.micError': 'Could not start the microphone.',
  'pm.notif.confirmTitle': 'Confirm notification',
  'pm.notif.fieldType': 'Notification type',
  'pm.notif.photoHint': 'Add photo — not active yet in the prototype',
  'pm.notif.createBtn': 'Create notification',
  'pm.notif.creating': 'Creating…',
  'pm.notif.successTitle': 'Notification created',
  'pm.notif.notifNumber': 'Notification number',
  'pm.notif.createHint': 'Created in SAP (via the mock adapter)',
};

export default pm;
